import { Component } from "react";
import {
    DKLabel,
    DKInput,
    DKButton,
    DKLine,
    showToast,
    TOAST_TYPE,
    showLoader,
    removeLoader,
  } from "deskera-ui-library";
import RouteManager from "../../../managers/RouteManager";
import { MY_TAX_DETAILS_FORM } from "./MYConstants";
import Utility from "../../../utility/Utility";
import TaxService from "../../../services/compliance/TaxSerivce";
import { getTenantCountryCode } from "../../../managers/common/CommonUtil";
import EmployeeListService from "../../../services/EmployeeListService";
import PermissionUtils, { ACTION, MODULE } from "../../user-permissions/PermissionUtils";
export default class MYTaxdetails extends Component {
    myTaxFormField = MY_TAX_DETAILS_FORM;
    myTaxData = {
        compliance: {
            "@type": "type.googleapis.com/v1.MYTaxDetails",
            companyTaxNumber: "",
            eisNumber: "",
            empTaxNumber: "",
            hrdfNumber: "",
            registrationNumber: "",
            socsoNumber: "",
            zakatNumber: ""
        }
    };
    canValidate = false;
    interval;
    hasAccessToEdit = PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS,[ACTION.EDIT])
    constructor(props) {
        super(props)
        RouteManager.setPresenter(this);
        this.getTaxDetails();
    }
    componentWillUnmount() {
        if(this.interval) {
            clearInterval(this.interval)
        }
    }
    getTaxDetails() {
        showLoader()
        TaxService.getTaxDetail(getTenantCountryCode()).then(res=>{
            removeLoader()
            this.myTaxData = res;
            this.updateState()
        },error=>{
            removeLoader()
        })
    }
    updateState() {
        this.setState({...this.state})
    }
    navigateTo = () => {
        RouteManager.navigateToPage('')
    }
    save = () => {
        this.canValidate = true;
        this.updateState()
        this.interval = setTimeout(() => {
            let isInvalid = false;
            this.myTaxFormField.forEach(field => {
                if (field.required && (Utility.isEmpty(this.myTaxData.compliance[field.columnCode]) || !field.isValid)) {
                    isInvalid = true;
                } else if (!Utility.isEmpty(this.myTaxData.compliance[field.columnCode]) && !field.isValid) {
                    isInvalid = true;
                }
            })
            if (isInvalid) {
                this.updateState()
                return;
            } else {
                showLoader()
                TaxService.saveTaxDetail(getTenantCountryCode(), this.myTaxData).then(res => {
                    removeLoader()
                    if(this.myTaxData.id) {
                        showToast("Tax details updated successfully.",TOAST_TYPE.SUCCESS);
                    } else {
                        showToast("Tax details saved successfully.",TOAST_TYPE.SUCCESS);
                    }
                    this.navigateTo()
                })
            }
        }, 100)
    }
    getFieldValue(obj) {
        switch (obj.columnCode) {
            
            default:
                return this.myTaxData.compliance[obj.columnCode]
        }
        

    }
    onChange(value, index, obj){
        const alteredConfig = [];
        // switch (obj.columnCode) {
            
        //     default:
        //          this.myTaxData.compliance[obj.columnCode] = value
        // }
        if (obj.validation && obj.validation.regExp && !Utility.isEmpty(value.trim())) {
            const regex = new RegExp(obj.validation.regExp);
            alteredConfig.push({columnCode: obj.columnCode, isValid: regex.test(value)});
        } else if (obj.required && typeof value === "string" && Utility.isEmpty(value.trim())) {
            alteredConfig.push({columnCode: obj.columnCode, isValid: false});
        } else if (obj.required && Utility.isEmpty(value)) {
            alteredConfig.push({columnCode: obj.columnCode, isValid: false});
        } else if (obj.validation && obj.validation.range) {
            if(obj.validation.range.maxLength &&obj.validation.range.maxLength>=value.length) {
                alteredConfig.push({columnCode: obj.columnCode, isValid: true});
            } else if(obj.validation.range.maxValue && obj.validation.range.maxValue>=value) {
                alteredConfig.push({columnCode: obj.columnCode, isValid: true});
            } else {
                alteredConfig.push({columnCode: obj.columnCode, isValid: false});
            }
            
        }
        else {
            obj.isValid = true;
            alteredConfig.push({columnCode: obj.columnCode, isValid: true});
            return true;
        }
        this.myTaxData.compliance[obj.columnCode] = value
        EmployeeListService.getAlteredConfigDetails(this.myTaxFormField, alteredConfig,false, {}, {});
        this.updateState();
    }
    getFormField = (obj, index) => {
        return (
            <div className="d-flex">
                <DKInput
                    className={"p-v-s mb-l p-h-l"}
                    icon={obj.icon}
                    title={obj.name}
                    placeholder={obj.name}
                    value={this.getFieldValue(obj)}
                    options={obj.options}
                    type={obj.type}
                    errorMessage={obj.errorMessage}
                    labelClassName=" text-align-left "
                    invalid={!obj.isValid}
                    canValidate={!obj.isValid }
                    onChange={(value) => {
                        this.onChange(value, index, obj);
                    }}
                    tooltip={{
                        content: obj.tooltipText,
                        className: "warning-tooltip-prop",
                    }}
                    validator={(value) => {
                        return obj.isValid;
                    }}
                    formatter={(obj) => {
                        /** How to render a selected option in case of object **/
                        return obj.name;
                    }}
                    dropdownConfig={{
                        className: "",
                        style: {},

                        data: obj.options,
                        renderer: (index, obj) => {
                            /** How to render value in Dropdown in case of object **/
                            return <DKLabel text={`${obj.name}`} />;
                        },
                        onSelect: (index, obj) => {

                        },
                    }}
                    direction={obj.direction}
                    required={obj.required}
                    readOnly={obj.readOnly || !this.hasAccessToEdit}
                />
                {obj.suffixIcon && <DKLabel style={{ marginLeft:-44 }} className="fs-m z-index-1 d-flex align-items-center" text={obj.suffixIcon}/>}
            </div>
        )
    }
    getHeader = () => {
        return (
            <div className="parent-width d-flex justify-content-between mb-l">
                <DKLabel
                    text="Tax Details"
                    className=" fs-r text-align-left fw-m fs-l"
                />
                <div className="d-flex">
                    <DKButton
                        title="Cancel"
                        className="border-radius-m bg-gray1 border-m mr-m"
                        onClick={() => {
                            this.navigateTo()
                        }}
                    />
                    {this.hasAccessToEdit && <DKButton
                        title="Save"
                        className="bg-app text-white"
                        onClick={() => {
                            this.save()
                        }}
                    />}
                </div>
            </div>
        )
    }
    render() {
        return(
            <>
                {this.getHeader()}
                <div className=" parent-width bg-white border-radius-s card-shadow">
                <div className="d-flex flex-wrap">
                <DKLabel text="Tax Details" className="p-l fw-m" />
                <DKLine className="bg-gray3 mb-s" />
                {
                    this.myTaxFormField.map((field, index) => {
                        return (<div className="web-width-50 ">{this.getFormField(field, index)}</div>)
                    })
                }
                </div>
                
                </div>
            </>
        )
    }
}